import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { level1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon0 from "@js/public/images/Ribbon0.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import {
    lesson1DefaultEndCode,
    lesson1DefaultStartCode,
    lesson1DefaultMiddleCode,
} from "./lesson1";
import {
    lesson2DefaultEndCode,
    lesson2DefaultMiddleCode,
    lesson2DefaultStartCode,
} from "./lesson2";
import {
    lesson3DefaultEndCode,
    lesson3DefaultMiddleCode,
    lesson3DefaultStartCode,
} from "./lesson3";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import { m5l0Solution } from "./lesson0Solution";
import { m5l1Solution } from "./lesson1Solution";
import { m5l2Solution } from "./lesson2Solution";
import { m5l3Solution } from "./lesson3Solution";

export const starklingsRegistersConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 5,
        moduleName: "starklingsRegisters",
        timeEstimate: "1 hr",
        title: "Starklings Registers",
        description: `Welcome to the intro of Starklings Registers lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS REGISTERS",
            badgeCaption: "A level 6 Starkling",
            ribbonImgSrc: Ribbon0.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: level1ModuleCompleteColor,
            badgeTokenId: 8,
        },
    },
    lessons: [
        {
            timeEstimate: "5-10 min",
            title: "Register00",
            formattedDescription: `
[{"type":"paragraph","children":[{"text":"Solve the starklings Register00 lesson"}]}]            
`,
            hints: [],
            defaultEndCode: lesson0DefaultEndCode,
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            id: 0,
            solution: m5l0Solution,
        },
        {
            timeEstimate: "5-10 min",
            title: "Register01",
            formattedDescription: `
[{"type":"paragraph","children":[{"text":"Solve the starklings Register01 lesson"}]}]            
`,
            hints: [],
            defaultStartCode: lesson1DefaultStartCode,
            defaultMiddleCode: lesson1DefaultMiddleCode,
            defaultEndCode: lesson1DefaultEndCode,
            id: 1,
            solution: m5l1Solution,
        },
        {
            timeEstimate: "10-20 min",
            title: "Register02",
            formattedDescription: `
[{"type":"paragraph","children":[{"text":"Solve the starklings Register02 lesson"}]}]            
`,
            hints: [],
            defaultStartCode: lesson2DefaultStartCode,
            defaultMiddleCode: lesson2DefaultMiddleCode,
            defaultEndCode: lesson2DefaultEndCode,
            id: 2,
            solution: m5l2Solution,
        },
        {
            timeEstimate: "10-20 min",
            title: "Register03",
            formattedDescription: `
[{"type":"paragraph","children":[{"text":"Solve the starklings Register03 lesson"}]}]            
`,
            hints: [],
            defaultStartCode: lesson3DefaultStartCode,
            defaultMiddleCode: lesson3DefaultMiddleCode,
            defaultEndCode: lesson3DefaultEndCode,
            id: 3,
            solution: m5l3Solution,
        },
    ],
};
